import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-inputgroup" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_FloatLabel, {
      label: _ctx.$t(`shift.${_ctx.field}.label`)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AutoComplete, {
          modelValue: _ctx.modelValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
          minLength: 2,
          suggestions: _ctx.suggestions,
          field: _ctx.field,
          label: _ctx.$t(`shift.${_ctx.field}.placeholder`),
          onComplete: _ctx.search,
          onItemSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSelect($event.value)))
        }, null, 8, ["modelValue", "suggestions", "field", "label", "onComplete"])
      ]),
      _: 1
    }, 8, ["label"])
  ]))
}